'use strict'

_isElementInViewport = require './is_element_in_viewport'

module.exports = (el) ->
  el and not el.classList.contains('hidden') and _isElementInViewport(el)